import GenesysDriver from '../genesys/apiv2';
import BotDriver from './bot/';
import Helper from './Helper';

export class API {
    constructor(store) {
        this.store = store;
        this.session = null;
        this.messagePreview = null;
        this.genesys = new GenesysDriver(store);
        this.bot = new BotDriver(store);

        this.windowID = this.genesys.windowID;
        this.Helper = new Helper(this);

        const state = this.store.getState();
        this.APIMode = state.chat.mode;
    }

    start(userData) {
        this.Helper.open(userData);
    }

    close() {
        this.Helper.close();
    }

    sendMessage(message) {
        this.Helper.sendRequest({
            command: 'send',
            parameters: {
                message: message,
                messageType: 'text'
            }
        });
    }

    sendUserData(userData, successCallback = null) {
        if(userData) {
            this.Helper.sendRequest({
                command: 'updateData',
                parameters: {
                    userData
                },
                callbacks: {
                    success: successCallback
                }
            });
        }
        else if(successCallback) {
            successCallback();
        }
    }

    sendTyping(messagePreview) {
        this.Helper.sendTyping(messagePreview);
    }
}
